import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function ModernHeaderButton(props: { id?: string, icon: IconName, onClick: () => void, title: string, className?: string, variant?: 'primary' | 'secondary', text?: string }) {
  const clicked = () => {
    props.onClick();
  }

  const variantClass =
    props.variant === 'primary'
      ? 'btn-modern-primary'
      : props.variant === 'secondary'
      ? 'btn-modern-secondary'
      : '';
  return (
    <button id={props.id}
            className={`btn-modern ${variantClass} ${props?.className || ''}`}
            title={props.title}
            aria-label={props.title}
            onClick={clicked}
            onMouseDown={(e) => {
              // Verhindere, dass der Button nach dem Klick fokussiert bleibt
              e.currentTarget.blur();
            }}>
      <FontAwesomeIcon icon={props.icon} /> {props.text}
    </button>
  );
}

export default ModernHeaderButton;


